<template>
  <div>
    <mdb-container v-if="types.length > 0 && newGame.gameType == null">
      <mdb-row>
        <div class="col-md-6 d-flex align-self-stretch mb-4"
             v-for="(game,i) in types" :key="i">
          <mdb-card class="d-flex align-self-stretch mb-4">
            <mdb-card-header class="primary-color text-white">
              <h3>{{ game.name }}</h3>
            </mdb-card-header>
            <mdb-card-body class="text-left">
              {{ game.introText }}
              <div class="mt-2 text-info">Minimum # of Players: {{ game.minPlayers }}</div>
            </mdb-card-body>
            <mdb-card-footer>
              <mdb-btn @click="selectGame(game)" icon="check">Select</mdb-btn>
            </mdb-card-footer>
          </mdb-card>
        </div>
      </mdb-row>

    </mdb-container>
    <div v-if="newGame.gameType" class="text-left">
      <div class="mb-2">
        <label class="formless-label" for="game-type">Game Type Selected</label>
        <select id="game-type" v-model="newGame.gameType" class="browser-default custom-select" disabled
                placeholder="Select Game Type">
          <option v-for="type in types" :value="type.id" :key="'g' + type.id">{{ type.name }}</option>
        </select>
        <mdb-btn @click="newGame.gameType=null" size="sm" rounded color="warning">Change Game</mdb-btn>
      </div>
      <label v-if="availableDecks.length>0" class="formless-label" for="game-deck">Deck</label>
      <select id="game-deck" v-if="availableDecks.length>0" v-model="newGame.deck"
              class="browser-default custom-select"
              placeholder="Select Deck">
        <option v-for="(deck,i) in availableDecks" :value="deck.id" :key="'d' + i">{{ deck.name }}</option>
      </select>
      <mdb-input id="guests" v-model="newGame.allowGuests"
                 label="Allow Guests?"
                 name="guests" type="checkbox"/>
      <mdb-input v-if="!isChange" id="gameCode"
                 v-model="newGame.gameCode" label="Join Code/Password"
                 name="gameCode" type="text"/>
      <div v-if="!isChange" class="text-info small">If you don't assign a game code, one will be assigned for you. It
        might
        be naughty.
      </div>
      <mdb-btn :disabled="!newGame.gameType" icon="play" @click="$emit('newCampfire', newGame)">Start</mdb-btn>
    </div>
    <mdb-btn color="danger" icon="times-circle" @click="$emit('cancelStart')">Cancel</mdb-btn>
  </div>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {mdbBtn, mdbCard, mdbCardBody, mdbCardFooter, mdbCardHeader, mdbContainer, mdbInput, mdbRow} from 'mdbvue';

export default {
  name: "campfire-start-dialog",
  components: {
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbInput,
    mdbRow,
    mdbContainer
  },
  props: {
    isChange: {
      Type: Boolean,
      Default: false
    },
  },
  data() {
    return {
      newGame: {gameType: null, allowGuests: false, gameCode: "", deck: null},
      types: []
    }
  },
  computed: {
    availableDecks() {
      let decks = []
      for (let type of this.types) {
        if (type.id == this.newGame.gameType) decks = type.decks
      }
      return decks
    },
    currentGame() {
      return this.newGame.gameType
    }
  },
  watch: {
    currentGame(n, o) {
      this.$nextTick().then(() => {
        let el = document.getElementById("game-deck")
        if (el) {
          el.selectedIndex = 0;
          this.newGame.deck = el.options[0].value
        }
      })
    }
  },
  mounted() {
    this.getCampfireTypes()
  },
  methods: {
    selectGame(g) {
      this.newGame.gameType = g.id
    },
    getCampfireTypes() {
      this.$store.dispatch("setExecuting", true)
      api.get("/campfire/types/").then(
        (results) => {
          this.types = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};
</script>
